import gql from 'graphql-tag';

export const GET_ORDER = gql`
  query getOrder($id: ID!) {
    order(id: $id) {
      id
      invoicedAt
      medical
      total
      totalExcl
      amountOutstanding
      refundableAmount
      transactionFee
      vatSummary {
        percentage
        unitVat
        priceExcl
      }
      number
      state
      invoiceEmailSubjectTemplate
      employeeNames
      items {
        description
        employee {
          id
          name
        }
        id
        quantity
        price
        priceExcl
        transactionCost
      }
      customer {
        id
        email
        firstName
        lastName
        fullName
        mobilePhone
        phone
        picture
        loyaltyPoints
        personalRegistrationNumber
        address
        zipcode
        city
        dateOfBirth
        insuranceProvider
      }
      transactions {
        id
        amount
        type
      }
    }
  }
`;

export const GET_PAYMENT_METHODS = gql`
  query getPaymentMethods($register: Boolean) {
    paymentMethods(register: $register)
  }
`;

export const ISSUE_INVOICE = gql`
  mutation issueSaleInvoice($input: IssueSaleInvoiceInput!) {
    issueSaleInvoice(input: $input) {
      document {
        id
      }
      errors
    }
  }
`;

export const SEND_DOCUMENT = gql`
  mutation sendSaleDocument($input: SendSaleDocumentInput!) {
    sendSaleDocument(input: $input) {
      errors
    }
  }
`;

export const UPDATE_ORDER = gql`
  mutation updateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      order {
        id
        customer {
          id
          fullName
        }
      }
      errors
    }
  }
`;
